import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ProgressCircle from '../../../components/ProgressCircle'
import firebaseGetImageUrl from '../../../helpers/firebaseGetImageUrl'
import { GetArchDeliveryWithPid } from '../../../services/get-arch-delivery'

export default function ArchDeliveryScreen() {
  const { order_number } = useParams();
  const [loading, setLoading] = useState(false);
  const [delivery, setDelivery] = useState(null);
  const [_photos, setPhotos] = useState([]);


  async function GetFullDeliveryInfo() {
    if (loading) return;
    setLoading(true)
    const delivery = await GetArchDeliveryWithPid(order_number)
    setDelivery(delivery || null)
    setLoading(false)

    // load images
    const output = [];
    const photos = delivery.prod.photos;
    for (let i = 0; i < photos.length; i++) {
      const photo = photos[i];
      const url = await firebaseGetImageUrl(photo);
      output.push(url);
    }
    setPhotos(output);
  }


  useEffect(() => {
    GetFullDeliveryInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return <div style={{ width: 'max-content', margin: 'auto', marginTop: '42vh' }}>
      <ProgressCircle />
    </div>;
  }

  return (
    <div className="container-sm p-2">
      <div style={{ maxWidth: 600, margin: 'auto' }}>
        {/* Context */}
        {delivery &&
          <div className={"card p-3 shadow"}>
            <h1># {delivery.order_number && delivery.order_number}</h1>
            <h2>{delivery.prod.category && delivery.prod.category}</h2>
            <h3>{delivery.prod.subCategory && delivery.prod.subCategory}</h3>
            <h4>{delivery.prod.brand && delivery.prod.brand}</h4>
            <div className={"card p-2 mt-2"}>
              <h4>გამყიდველი</h4>
              <a href={`/p/${delivery.seller.uid}`} >სახელი: {delivery.seller.firstName && delivery.seller.firstName}</a>
              <p>ნომერი: {delivery.seller.mobileNumber && delivery.seller.mobileNumber}</p>
              <p>მისამართი: {delivery.seller.address && delivery.seller.address}</p>
              <a className={"btn btn-primary"} href={`tel: ${delivery.seller.mobileNumber && delivery.seller.mobileNumber}`}>
                დარეკვა: {delivery.seller.mobileNumber && delivery.seller.mobileNumber}
              </a>
            </div>
            <div className={"card p-2 mt-2"}>
              <h4>მყიდველი</h4>
              <a href={`/p/${delivery.buyer.uid}`} >სახელი: {delivery.buyer.firstName && delivery.buyer.firstName}</a>
              <p>ნომერი: {delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}</p>
              <p>მისამართი: {delivery.buyer.address && delivery.buyer.address}</p>
              <a className={"btn btn-primary"} href={`tel: ${delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}`}>
                დარეკვა: {delivery.buyer.mobileNumber && delivery.buyer.mobileNumber}
              </a>
            </div>

            <div>
              {_photos.map((photo, index) => {
                return (<img key={index} onClick={() => { window.open(photo, '_blank'); }}
                  style={{ width: '100%' }} alt={""} src={photo} />);
              })}
            </div>

          </div>}
      </div>
    </div>
  )
}
